import { Page, Layout } from "@shopify/polaris";

import AppInput from "../componens/appInput";
import AppTable from "../componens/appTable";

export default function DashBoard({ canManage = false }) {
  return (
      <Page>
        <Layout>
          {canManage && <Layout.Section><AppInput /></Layout.Section>}
          <Layout.Section>
            <AppTable canManage={canManage} />
          </Layout.Section>
        </Layout>
      </Page>
  );
}
